<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Time Zone
              <router-link
                :to="{ name: 'AccountAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Time Zone</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ 'item' | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete"
                    >Delete Selected Items</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button> -->
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px">
                        <i class="fas fa-search"></i> Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        <i class="fas fa-undo"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <!-- <th style="width: 10px">
                    <input
                      type="checkbox"
                      v-model="is_selected_all"
                      @click="selectedRowAll()"
                    />
                  </th> -->
                      <!-- <th>ID <sort-icons :_sort="'id'" /></th> -->
                      <th>User ID</th>
                      <th>Time Zone</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <!-- <td>
                    <input
                      type="checkbox"
                      v-model="selected_row"
                      :value="val.id"
                    />
                  </td> -->
                      <!-- <td>{{ val.id }}</td> -->
                      <td>{{ val.activation_email }}</td>
                      <td>{{ getTimeZoneName(val.zone_time) }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionView == true"
                          :to="{ name: 'AccountShow', params: { id: val.id } }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          v-if="actionEdit == true || checkEditPermission(val)"
                          :to="{ name: 'AccountEdit', params: { id: val.id } }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="
                            actionDelete == true && checkDeletePermission(val)
                          "
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import { CommonAPI, PermissionChecker } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import { Notification } from 'element-ui'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapGetters } from 'vuex'
const fileDownload = require('js-file-download')

export default {
  name: 'Account',
  metaInfo: {
    title: 'Account | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: {
      timeZoneList: [],
      audraName: []
    },
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false
  }),
  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url = '/accounts'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize () {
      this.is_loading = true
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      await CommonAPI.getCustomPermission(
        '/get-custom-permission-infos?path=api/accounts'
      ).then(response => {
        if (response.status == 200) {
          this.custom_permission_data = response.data
        }
      })

      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['create_id_condition'],
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      }

      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.getTimeZone()
      this.is_loading = false
    },
    async getFilterData () {
      this.is_loading = true
      await this.getList()
        .then(response => {
          this.list = response
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    reload: function () {
      this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page }
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get('accountId'),
          ...this.$route.query,
          ...params
        }
        axios
          .get(this.api_url, {
            params: params
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          })
      })
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    async resetFilter () {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      await this.getList()
        .then(response => {
          this.list = response
        })
        .catch(error => {
          this.empty = true

          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    deleteObject: function (id, index) {
      const _this = this
      const delete_api_url = '/accounts/' + id

      _this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.isConfirmed) {
            _this.is_loading = true
            axios
              .delete(delete_api_url)
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire('Failed!', 'failed to delete.', 'error')
              })
              .finally(() => {
                _this.is_loading = false
              })
          }
        })
    },
    exportFile: function () {
      this.is_loading = true
      axios
        .get('/accounts-export', { responseType: 'blob' })
        .then(response => {
          fileDownload(response.data, 'accounts.xlsx')
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
          Notification.success({
            title: 'Export Completed',
            message: 'Export operation completed successfully',
            type: 'success'
          })
        })
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all)
      if (isSelectedAll) {
        var items = []
        this.list.data.forEach(function (item) {
          items.push(item.id)
        })
        this.selected_row = items
      } else {
        this.selected_row = []
      }
    },
    handleSelectedRows (command) {
      if (command === 'delete') {
        axios({
          method: 'delete',
          url: '/accounts/delete-all',
          data: { ids: this.selected_row },
          headers: { 'Content-Type': 'application/json' }
        })
          .then(function (response) {
            Notification.success({
              title: 'Deleted Successfully',
              message: 'Data deleted successfully',
              type: 'success'
            })
            this.initialize()
          })
          .catch(errors => {
            if (!_.isEmpty(errors.response) && errors.response.status === 500) {
              this.$toaster.error(errors.response.data.message)
            }
          })
          .finally(() => {
            this.is_selected_all = false
            this.initialize()
          })
      }
    },
    getTimeZone: function () {
      axios
        .get('get-time-zone', {
          params: {}
        })
        .then(response => {
          this.pre.timeZoneList = response.data
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {})
    },
    getTimeZoneName (timezoneId) {
      return this.pre.timeZoneList[timezoneId] || '(GMT+06:00) Dhaka'
    }
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
